import { NavList } from "../shared";
import AppList from "./application-list.json";

const SystemAdminAppList = () => {
    return <NavList title="Application List" navList={AppList.systemAdmin} />;
};

export default SystemAdminAppList;
